/**
 * Product Recommendations Service
 *
 * Fetches active recommendations for user contexts, tracks events, and handles dismissals.
 */

import { supabase } from '@/lib/supabase';
import type {
  ActiveRecommendation,
  RecommendationPlacement,
  RecommendationTargetMode,
} from '@parentpath/supabase-client';

export async function getActiveRecommendation(params: {
  placement: RecommendationPlacement;
  locale: 'de' | 'en';
  mode: RecommendationTargetMode;
  ssw: number | null;
  babyAgeMonths: number | null;
  isPremium: boolean;
}): Promise<ActiveRecommendation | null> {
  const { data, error } = await supabase.rpc('get_active_recommendation', {
    p_placement: params.placement,
    p_locale: params.locale,
    p_mode: params.mode,
    p_ssw: params.ssw,
    p_baby_age_months: params.babyAgeMonths,
    p_is_premium: params.isPremium,
  });

  if (error) {
    console.error('Error fetching recommendation:', error);
    return null;
  }

  const rows = data as ActiveRecommendation[] | null;
  return rows && rows.length > 0 ? rows[0] : null;
}

export async function dismissRecommendation(recommendationId: string): Promise<void> {
  const { error } = await supabase.rpc('dismiss_recommendation', {
    p_recommendation_id: recommendationId,
  });
  if (error) throw error;
}

export async function trackRecommendationEvent(
  recommendationId: string,
  eventType: 'impression' | 'click',
  placement: RecommendationPlacement
): Promise<void> {
  const { error } = await supabase.rpc('track_recommendation_event', {
    p_recommendation_id: recommendationId,
    p_event_type: eventType,
    p_placement: placement,
  });
  if (error) {
    console.error('Error tracking recommendation event:', error);
  }
}
